import { createFileRoute, redirect } from '@tanstack/react-router'
import ForgotPasswordPage from '@/views/forgot-password'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/auth/forgot-password')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user) {
      throw redirect({
        to: '/dashboard'
      })
    }
  },
  component: ForgotPasswordPage,
})
